module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Automate the easy way","description":"Have a simple need? Automate individual workflows with Easy Automations.","action":"Create automation"}}')
  delete Component.options._Ctor
}
